import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        css: css`
            cursor: pointer;
            && :hover {
                border-color: ${color("common.black")};
            }
        `,
    },
} as xBaseTheme["select"];
